import loadable from "@loadable/component";
import Card from "../../components/Reusable/Card";
import Spinner from "../../components/Reusable/Spinner";
import SwitchTab from "../../components/Reusable/SwitchTab";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
const SettingComponent = loadable(() => import("../../components/Setting/"));
const Setting = () => {
  const { data, isLoading } = useGetHook({
    url: APIS.COMPANY_PROFILE,
    queryKey: ["company-profile"],
    params: {},
  });
  const tabs = [
    { id: "settings", label: "Profile", href: "/accounting/profile" },
    {
      id: "configuration",
      label: "Configuration",
      href: "/accounting/configuration",
    },
    {
      id: "setting",
      label: "Setting",
      href: "/accounting/settings",
    },
    {
      id: "settings-ird",
      label: "Setting IRD",
      href: "/accounting/settings-ird",
    },
  ];
  return (
    <>
      <div>
        <SwitchTab tabs={tabs} />
        {isLoading ? (
          <Spinner />
        ) : (
          <Card>
            <SettingComponent data={data} />
          </Card>
        )}
      </div>
    </>
  );
};

export default Setting;
